export enum NoResultsTypeEnum {
  'simple',
  'custom',
}

export interface NoResultsProps {
  type: NoResultsTypeEnum
  className?: string
  noResultsText?: string
}
